// Here is a list of the toolbar
// Detail list see https://www.tinymce.com/docs/advanced/editor-control-identifiers/#toolbarcontrols

const toolbar = [
    "searchreplace bold italic underline strikethrough alignleft aligncenter alignright outdent indent  blockquote undo redo removeformat subscript superscript code codesample",
    "fontsizeselect forecolor hr bullist numlist link image charmap preview anchor pagebreak insertdatetime media table",
];
// backcolor fullscreen emoticons
export default toolbar;
